import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DoraemonService {
  private doremonUrl = environment.s3baseUrl;
  private doremonDocKey = environment.doremonDocKey;

  constructor(private http: HttpClient) { }

  downloadDocWithS3Url(id: number | string, key: string): Observable<{ documentUrl: string }> {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: this.doremonDocKey
      }),
      responseType: 'json' as const
    };

    return this.http.get<{ documentUrl: string }>(
      `${this.doremonUrl}doraemon/api/v1/document/${id}/${key}/url`,
      httpOptions
    );
  }
}
